import { SVGProps } from 'react';

export const ExclamationMarkIcon = (props: SVGProps<any>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.44101 10.6772C7.59297 10.5342 7.79384 10.4546 8.00252 10.4548C8.21952 10.4548 8.42845 10.541 8.58189 10.6945C8.73534 10.8479 8.82154 11.056 8.82154 11.273C8.82154 11.49 8.73534 11.6981 8.58189 11.8515C8.42845 12.0049 8.22034 12.0911 8.00334 12.0911L7.90516 12.0854C7.69793 12.0608 7.50796 11.9579 7.3741 11.7978C7.24024 11.6377 7.17261 11.4325 7.18505 11.2242C7.19749 11.0159 7.28905 10.8202 7.44101 10.6772Z"
      fill="currentColor"
    />
    <path
      d="M7.53954 4.82085C7.68495 4.75936 7.84122 4.72771 7.99909 4.72778C8.1663 4.72776 8.3316 4.76331 8.48402 4.83206C8.63644 4.90081 8.77249 5.00119 8.88314 5.12654C8.9938 5.25189 9.07652 5.39934 9.12583 5.5591C9.17513 5.71887 9.18989 5.88729 9.16912 6.0532L8.81075 8.92002L8.79438 9.01247C8.74913 9.19846 8.64009 9.36268 8.48624 9.47658C8.3324 9.59048 8.14349 9.64683 7.95238 9.63584C7.76128 9.62484 7.58008 9.5472 7.44032 9.41641C7.30055 9.28562 7.21107 9.10997 7.18744 8.92002L6.82907 6.0532L6.82089 5.94275C6.81595 5.78496 6.84278 5.62779 6.89978 5.48057C6.95678 5.33336 7.04278 5.1991 7.15268 5.08577C7.26259 4.97244 7.39414 4.88235 7.53954 4.82085Z"
      fill="currentColor"
    />
  </svg>
);
